export default {
  'menu.providerManagement': 'サービスプロバイダー管理',
  'menu.providerManagement.admission': '入居管理',
  'menu.providerManagement.admissionApply': '入居申請',
  'menu.providerManagement.providerCompanies': '法人管理',
  'menu.providerManagement.providerCompanyDetail': '法人資格詳細',
  'menu.admission': '入居管理',
  'menu.admissionApply': '入居申請',
  'menu.providerCompanies': '法人管理',
  'menu.providerCompanyDetail': '法人資格詳細',
  'menu.customerManagement': '顧客運営',
  'menu.customerManagement.leads': 'リード',
  'menu.customerManagement.leadDetail': 'リード詳細',
  'menu.customerManagement.customers': '企業顧客',
  'menu.customerManagement.customerDetail': '顧客詳細',
  'menu.customerManagement.opportunities': '商談機会',
  'menu.customerManagement.opportunityDetail': '機会詳細',
  'menu.customers': '企業顧客',
  'menu.customerDetail': '顧客詳細',
  'menu.opportunities': '商談機会',
  'menu.opportunityDetail': '機会詳細',
  'menu.businessManagement': '業務管理',
  'menu.businessManagement.products': 'サービス商品',
  'menu.businessManagement.products.productCreate': '商品新規作成',
  'menu.businessManagement.products.productEdit': '商品編集',
  'menu.businessManagement.products.productDetail': '商品詳細',
  'menu.businessManagement.orders': 'サービス注文',
  'menu.businessManagement.orders.orderDetail': '注文詳細',
  'menu.products': 'サービス商品',
  'menu.productCreate': '商品新規作成',
  'menu.productEdit': '商品編集',
  'menu.productDetail': '商品詳細',
  'menu.orders': 'サービス注文',
  'menu.orderDetail': '注文詳細',
  'menu.projects': 'サービスプロジェクト',
  'menu.projectDetail': 'プロジェクト詳細',
  'menu.serviceQuality': 'サービス品質',
  'menu.serviceQuality.reviews': 'サービス評価',
  'menu.serviceQuality.qualityImprovements': '品質改善',
  'menu.reviews': 'サービス評価',
  'menu.qualityImprovements': '品質改善',
  'menu.analytics': '運営分析',
  'menu.settings.capabilities': 'サービスケイパビリティ',
  'menu.settings.reviewTags': '評価タグ',
  'menu.capabilities': 'サービスケイパビリティ',
  'menu.reviewTags': '評価タグ',
  'menu.workbench': 'ワークベンチ',
  'menu.more-blocks': 'その他のブロック',
  'menu.home': 'ホーム',
  'menu.admin': '管理者',
  'menu.admin.sub-page': 'サブページ',
  'menu.settings': 'システム設定',
  'menu.settings.permissions': '権限管理',
  'menu.login': 'ログイン',
  'menu.dashboard': 'ダッシュボード',
  'menu.dashboard.analysis': '分析',
  'menu.dashboard.monitor': 'モニター',
  'menu.dashboard.workplace': '職場',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'フォーム',
  'menu.form.basic-form': '基本フォーム',
  'menu.form.step-form': 'ステップフォーム',
  'menu.form.step-form.info': 'ステップフォーム（転送情報の書き込み）',
  'menu.form.step-form.confirm': 'ステップフォーム（転送情報の確認）',
  'menu.form.step-form.result': 'ステップフォーム（完成）',
  'menu.form.advanced-form': '高度なフォーム',
  'menu.list': 'リスト',
  'menu.list.table-list': '検索テーブル',
  'menu.list.basic-list': '基本リスト',
  'menu.list.card-list': 'カードリスト',
  'menu.list.search-list': '検索リスト',
  'menu.list.search-list.articles': '検索リスト(記事)',
  'menu.list.search-list.projects': '検索リスト(プロジェクト)',
  'menu.list.search-list.applications': '検索リスト(アプリ)',
  'menu.profile': 'プロフィール',
  'menu.profile.basic': '基本プロフィール',
  'menu.profile.advanced': '高度なプロフィール',
  'menu.result': '結果',
  'menu.result.success': '成功',
  'menu.result.fail': '失敗',
  'menu.exception': '例外',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'トリガー',
  'menu.account': 'アカウント',
  'menu.account.center': 'アカウントセンター',
  'menu.account.workbench': 'ワークベンチに戻る',
  'menu.account.tenantManagement': 'テナント管理',
  'menu.account.trigger': 'トリガーエラー',
  'menu.account.logout': 'ログアウト',
  'menu.editor': 'グラフィックエディタ',
  'menu.editor.flow': 'フローエディタ',
  'menu.editor.mind': 'マインドエディター',
  'menu.editor.koni': 'コニエディター',
};
